import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const CellContainer = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    position: relative;
    top: 0;
    border-bottom: 1px solid ${colours.grey[400]};
  `;
});

export const Header = styled.header(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    position: sticky;
    top: 192px;
    z-index: 1;
    height: 47px;
    min-height: 47px;
    background-color: ${colours.grey[200]};
  `;
});

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
`;

export const GridColumn = styled.div`
  display: flex;
  flex-direction: column;
`;



// WEBPACK FOOTER //
// ./components/grid/styled.js